<template>
  <!-- 我的工单 -->
  <div>
    <p>
      <span class="strong">{{widget.label || widget.id}}</span>
    </p>
    <div class="hover-shadow box-border-7">
      <div v-if="!myTicketList || myTicketList.length < 1"
        style="color:#EEE;font-size:20px;">没有...</div>

      <div class="ticket-title-line" v-for="e in myTicketList" :key="e.orderId">
        <TicketTitle class="ticket-title-line-1"
          :ticketTitle="e.orderTitle"
          :ticketNo="e.orderId"
          target="_blank"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .ticket-title-line {
    margin: 5px 0 0 -15px;
    padding: 0 0 0 15px;
    border-bottom: 1px solid #f7f7f7;
  }

  .ticket-title-line-1 {
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
    display: inline-block;
    width: 100%;
  }
</style>

<script>
export default {
    name : 'TicketWidgetRelated',

    props : ['widget'],

    data() {
      return {
        myTicketList : []
      }
    },

    mounted() {
      this.loadMyTicketList();
    },

    methods: {
      loadMyTicketList() {
        var _this = this;
        sdk.TicketApi().listRelatedTicket({
          ticketNo: _this.$route.query.orderId,
          page : { orderBy: "`create_time` DESC", pageSize : 10 }
        }).then(res => {
          if ( !res || !res.list ) {
            console.log('#61 listRelatedTicket', res);
            return;
          }

          _this.myTicketList = res.list;
        }, err => {
          console.log('#67 TicketApi listRelatedTicket ticket_not_visible', err);

          if ( 'ticket_not_visible' == err ) {
            _message('TicketApi.listRelatedTicket 你没有权限查看这个工单 ' + _this.$route.query.orderId);
            return;
          }
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetRelated.vue